export default "__VITE_PUBLIC_ASSET__e1391f5d__"